(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  const setupPeptivaAlphabeticalCatalog = () => {
    document.querySelectorAll('results-list[data-peptiva-alpha-catalog]').forEach((catalog) => {
      const grid = catalog.querySelector('.product-grid');
      const index = catalog.querySelector('[data-alpha-index]');
      if (!grid || !index) return;

      const cards = Array.from(grid.querySelectorAll(':scope > li.product-grid__item[data-alpha-title]'));
      if (!cards.length) {
        index.replaceChildren();
        index.hidden = true;
        grid.dataset.alphaSignature = '';
        return;
      }

      const keyFor = (card) => (card.dataset.alphaTitle || '')
        .replace(/^(?:istraživački\s+spoj|research\s+compound)\s+/i, '')
        .trim();
      const locale = document.documentElement.lang || 'hr';
      const collator = new Intl.Collator(locale, { sensitivity: 'base', numeric: true });
      const signature = cards.map((card) => card.dataset.productId || card.dataset.alphaTitle).join('|');
      if (grid.dataset.alphaSignature === signature) return;
      grid.querySelectorAll(':scope > li.peptiva-alpha-heading').forEach((heading) => heading.remove());

      cards.sort((first, second) => collator.compare(keyFor(first), keyFor(second)));

      const groups = new Map();
      cards.forEach((card) => {
        const normalized = keyFor(card).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const firstCharacter = normalized.charAt(0).toLocaleUpperCase(locale);
        const letter = /^[A-Z]$/.test(firstCharacter) ? firstCharacter : '#';
        if (!groups.has(letter)) groups.set(letter, []);
        groups.get(letter).push(card);
      });

      const label = index.dataset.alphaLabel || 'Browse by letter';
      index.replaceChildren();
      index.hidden = false;

      const warmGroupImages = (heading) => {
        let item = heading.nextElementSibling;
        let warmed = 0;
        while (item && !item.classList.contains('peptiva-alpha-heading') && warmed < 4) {
          if (item.matches('li.product-grid__item')) {
            const image = item.querySelector('img');
            if (image) {
              image.loading = 'eager';
              image.fetchPriority = warmed < 2 ? 'high' : 'auto';
              if (!image.complete && image.currentSrc) image.src = image.currentSrc;
            }
            warmed += 1;
          }
          item = item.nextElementSibling;
        }
      };

      groups.forEach((items, letter) => {
        const targetId = letter === '#' ? 'peptiva-letter-numbers' : 'peptiva-letter-' + letter.toLowerCase();
        const link = document.createElement('a');
        link.href = '#' + targetId;
        link.textContent = letter === '#' ? '0–9' : letter;
        link.setAttribute('aria-label', label + ' ' + link.textContent);
        index.append(link);

        const heading = document.createElement('li');
        heading.className = 'peptiva-alpha-heading';
        heading.id = targetId;
        heading.setAttribute('aria-label', letter === '#' ? '0–9' : letter);
        const headingText = document.createElement('h2');
        headingText.textContent = letter === '#' ? '0–9' : letter;
        heading.append(headingText);
        link.addEventListener('pointerenter', () => warmGroupImages(heading), { passive: true });
        link.addEventListener('pointerdown', () => warmGroupImages(heading), { passive: true });
        link.addEventListener('click', () => warmGroupImages(heading));
        grid.append(heading, ...items);
      });

      grid.dataset.alphaSignature = Array.from(grid.querySelectorAll(':scope > li.product-grid__item[data-alpha-title]'))
        .map((card) => card.dataset.productId || card.dataset.alphaTitle)
        .join('|');
    });
  };

  let peptivaAlphabeticalFrame = 0;
  const schedulePeptivaAlphabeticalCatalog = () => {
    if (peptivaAlphabeticalFrame) return;
    peptivaAlphabeticalFrame = window.requestAnimationFrame(() => {
      peptivaAlphabeticalFrame = 0;
      setupPeptivaAlphabeticalCatalog();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePeptivaAlphabeticalCatalog, { once: true });
  } else {
    schedulePeptivaAlphabeticalCatalog();
  }

  if (!window.peptivaAlphabeticalCatalogObserver) {
    window.peptivaAlphabeticalCatalogObserver = new MutationObserver(schedulePeptivaAlphabeticalCatalog);
    window.peptivaAlphabeticalCatalogObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
